import { render } from "./SelectCaseCard.vue?vue&type=template&id=3d2e84fe&scoped=true"
import script from "./SelectCaseCard.vue?vue&type=script&lang=js"
export * from "./SelectCaseCard.vue?vue&type=script&lang=js"

import "./SelectCaseCard.vue?vue&type=style&index=0&id=3d2e84fe&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d2e84fe"]])

export default __exports__